<template>
  <div id="profile-page">
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title primary-title>Profile Information</v-card-title>
          <v-card-text class="form-profile">
            <v-layout wrap row-form align-center>
              <v-flex md3 xs12>
                <span class="label-form">First Name</span>
              </v-flex>
              <v-flex offset-md2 md6 xs12>
                <v-text-field
                        v-model="infoUser.first_name"
                        flat
                        solo
                        class="is-label-disabled"
                        disabled
                        hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap row-form align-center>
              <v-flex md3 xs12>
                <span class="label-form">Last Name</span>
              </v-flex>
              <v-flex offset-md2 md6 xs12>
                <v-text-field
                        v-model="infoUser.last_name"
                        flat
                        solo
                        class="is-label-disabled"
                        disabled
                        hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap row-form align-center>
              <v-flex md3 xs12>
                <span class="label-form">Email</span>
              </v-flex>
              <v-flex offset-md2 md6 xs12>
                <v-text-field
                        v-model="infoUser.email"
                        flat
                        solo
                        class="is-label-disabled"
                        disabled
                        hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap row-form align-center>
              <v-flex md3 xs12>
                <span class="label-form">Password</span>
              </v-flex>
              <v-flex offset-md2 md6 xs12>
                <v-btn class="icon-reset-password" small color="primary" @click="dialog = true">Change Password</v-btn>
              </v-flex>
            </v-layout>


          </v-card-text>
        </v-card>
        <v-dialog
                v-model="dialog"
                max-width="400px"
                persistent
        >
          <v-card class="dialog-change-password">
            <v-card-title
                    class="headline grey lighten-2"
                    primary-title
            >
              Change Your Password
            </v-card-title>

            <v-card-text class="pa-0">
              <div class="container pt-0 pb-0">
                <v-form
                        ref="formChangePass"
                        v-model="validForm"
                >
                  <div class="form-change-password">
                    <v-text-field
                            v-model="yourPassword.current"
                            label="Current Password"
                            type="password"
                            :rules="[rules.required, rules.minLength, rules.maxLength]"
                    ></v-text-field>
                    <v-text-field
                            v-model="yourPassword.newPass"
                            label="New Password"
                            type="password"
                            :rules="[rules.required, rules.requiredPass , rules.minLength, rules.maxLength]"
                    ></v-text-field>
                    <v-text-field
                            v-model="yourPassword.confirmPass"
                            label="Re-new Password"
                            type="password"
                            :rules="[rules.required, rules.requiredPass, rules.minLength, rules.maxLength, rules.confirm]"
                    ></v-text-field>
                  </div>
                </v-form>
              </div>

            </v-card-text>
            <p class="error-message" style="margin-bottom: 16px;font-size: 12px;">{{error_message}}</p>
            <!--<p class="success-message" style="margin-bottom: 16px;">{{success_message}}</p>-->
            <v-card-actions >
              <v-spacer></v-spacer>
              <v-btn
                      @click="cancel"
              >
                Cancel
              </v-btn>
              <v-btn
                      color="primary"
                      @click="changePassword"
                      :loading="isUpdate"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog max-width="450px" v-model="dialogConfirm" persistent>
          <v-card>
            <v-card-title>
              <span class="headline">Alert</span>
            </v-card-title>
            <v-card-text style="color: #4caf50; text-align: center">{{ success_message }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!--<v-btn @click="dialogConfirm = false" style="width: 85px">No</v-btn>
              <v-btn @click="close" color="primary" style="width: 85px">Yes</v-btn>-->
              <v-btn @click="ssChangePass" color="primary" style="width: 85px">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import store from "../store";
import Sha256 from "sha256";
export default {
    metaInfo() {
        return {
            title: "Profile Account"
        };
    },
    data() {
        return {
            dialog: false,
            dialogConfirm: false,
            yourPassword: {
                current: '',
                newPass: '',
                confirmPass: ''
            },
            rules: {
                required: value => !!value || 'It is required.',
                minLength: value => (value && value.length >= 6) || 'Min 6 characters',
                maxLength: value => (value && value.length <= 50) || 'Max 50 characters',
                confirm: value => value === this.yourPassword.newPass || 'Confirm Password wrong',
                requiredPass: v => (v && v.trim() !== '') || 'Password must be at least 1 character'
            },
            validForm: true,
            isUpdate: false,
            error_message: '',
            success_message: ''
        }
    },
    created() {
        this.$store.dispatch("auth/setCurrentUser");
    },
    watch: {
        dialog: function (val) {
            if (!val) {
                this.yourPassword.current = '';
                this.yourPassword.newPass = '';
                this.yourPassword.confirmPass = '';
            }
        },
        yourPassword: {
            handler() {
                this.error_message = '';
            },
            deep: true
        }
    },
    computed: {
        infoUser: function () {
            if (store.state.auth.currentUser === null) return [];
            else return store.state.auth.currentUser;
        }
    },
    methods: {
        cancel: function() {
            this.dialog = false;
            this.dialogConfirm = false;
            this.$refs.formChangePass.reset();
        },
        changePassword() {
            if (this.isUpdate) return;
            this.isUpdate = true;

            this.error_message = '';
            this.success_message = '';

            if (this.$refs.formChangePass.validate()) {
                let params = {
                    old_pass: Sha256(this.yourPassword.current),
                    new_pass: Sha256(this.yourPassword.newPass)
                };
                this.axios
                    .put("/users/password/change", params)
                    .then(res => {
                        this.isUpdate = false;
                        if (res.data && res.data.statusCode === 200) {
                            //this.$store.dispatch("auth/setCurrentUser");
                            this.dialogConfirm = true;
                            this.success_message = res.data.message;
                        } else {
                            this.error_message = res.data.message;
                        }
                    });
            } else {
                this.isUpdate = false;
            }
        },
        ssChangePass() {
            this.$store.dispatch("auth/logout");
        }
    }
}
</script>
<style>
  .v-card__title {
    font-size: 16px;
    font-weight: bold;
    background-color: #f5f5f5;
  }
  .form-profile {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
  }
  .is-label-disabled.theme--light.v-input--is-disabled .v-label, .is-label-disabled.theme--light.v-input--is-disabled input, .is-label-disabled.theme--light.v-input--is-disabled textarea {
    color: rgba(0, 0, 0, 0.87);
  }
  .form-profile .icon-reset-password {
    text-transform: capitalize;
    padding: 0px 15px;
  }
  .form-profile .label-form {
    text-align: right;
    display: block;
  }
  .form-change-password {
    width: 100%;
    max-width: 380px;
    margin: 0 auto;
  }
  .dialog-change-password .v-card__title {
    font-size: 20px !important;
    font-weight: bold;
    padding: 16px;
  }
  .dialog-change-password .v-card__actions {
    padding: 15px 10px;
  }
  .progress-line {
    margin: 0;
    height: 3px !important;
  }
  .progress-disable {
    opacity: 0;
  }
  .error-message {
    margin-bottom: 0;
    padding: 0 24px;
    color: rgb(255, 94, 68);
  }
  .success-message {
    margin-bottom: 0;
    padding: 0 24px;
    color: #4DAD51;
  }
  .dialog-change-password .v-card__actions {

  }
</style>
